// extracted by mini-css-extract-plugin
export default {"selected":"MapOrgsColumns_selected__aRDHj","assigned":"MapOrgsColumns_assigned__KvjiT"};